import { createContext } from 'react';

// Types
import { ICreateScenarioTranslations } from 'src/@scenarioGeneration/containers/CreateScenario/interfaces';

export const translationsContext = createContext<ICreateScenarioTranslations>(null);
